export const colors: string[] = [
  '#3F51B5',
  '#FF5722',
  '#2196F3',
  '#673AB7',
  '#607D8B',
  '#4CAF50',
  '#00BCD4',
  '#F44336',
  '#FFEB3B',
  '#E91E63',
  '#009688',
  '#795548',
  '#9C27B0',
  '#FFC107',
  '#FF9800',
  '#18FFFF',
  '#8BC34A',
  '#9E9E9E',
  '#CDDC39',
];
